class Description {

  constructor() {
    this.descriptionHandler()
  }

  descriptionHandler() {
    document.addEventListener('click', ev => {
      const toggle = ev.target.closest('.resultsGroup__toggle')
      if (!toggle) return
      const description = document.getElementById(toggle.getAttribute('aria-controls'))
      if (!description) return
      if (toggle.getAttribute('aria-expanded') === 'true') {
        // Go from "none" to a fixed height first, so the closing transition runs
        description.style.maxHeight = description.scrollHeight + "px"
        description.offsetHeight
        description.style.maxHeight = "0px"
        description.inert = true
        toggle.setAttribute('aria-expanded', 'false')
      } else {
        description.inert = false
        description.style.maxHeight = description.scrollHeight + "px"
        toggle.setAttribute('aria-expanded', 'true')
        // Once open, drop the limit so content added later (midlife crisis, color) still fits
        description.addEventListener('transitionend', () => {
          if (toggle.getAttribute('aria-expanded') === 'true') description.style.maxHeight = "none"
        }, { once: true })
      }
    })
  }

}

export default Description
